import container from '@/container'

export default function completeChecklistItem ({ dispatch }, itemId) {
  return dispatch('updateChecklistItem', {
    id: itemId,
    completedOn: container.make('dateTime').isoDate()
  })
}
